import {addListener} from "../../shared/interaction-listener";


function showAllBouts(this: HTMLElement, e: MouseEvent){
    e.preventDefault()
    this.classList.add('hidden');
    document.querySelectorAll('.bout').forEach(row => {
        if (row.classList.contains("hidden")){
            row.classList.remove("hidden")
        }
    })
}

function initFighterBouts(){
    const items = document.querySelectorAll('.bout');
    if (!items || items.length < 7){
        return;
    }
    for(let i = 0; i < items.length; i++){
        if (i > 6){
            items[i].classList.add("hidden")
        }
    }

    const el = document.querySelector<HTMLElement>('[js-show-bouts="true"]');
    if (el){
        el.classList.remove('hidden');
        el.addEventListener("click", showAllBouts);
    }
}

addListener(initFighterBouts)